<template>
  <v-row class="">
    <div class="flow-line">
      <div class="pt-8 flow-line-inside">&nbsp;</div>
    </div>
    <v-card outlined class="mx-auto py-1 px-8" width="95%" elevation="1">
      <v-row class="">
        <v-col cols="11" class="pt-0 px-0 mx-0"
          ><v-card-title>Redirect</v-card-title></v-col
        >
        <v-col cols="1" class="px-0"></v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-col cols="12">
            <v-autocomplete
              :disabled="PreviewMode"
              required
              :rules="[rules.required]"
              v-model="selectedRedirectTo"
              @change="onUpdateAnything"
              :items="otherCallFlows"
              item-text="name"
              item-value="id"
              :filter="callFlowsCustomFilter"
              label="Select a Call Flow"
              hint="Callers will redirect to this flow if they make it this far"
              persistent-hint
              dense
              autocomplete="off"
              outlined
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.name }}&nbsp;{{
                      item.id == FlowId ? "(current flow)" : ""
                    }}</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >{{ item.meta.flow.length }} steps</v-list-item-subtitle
                  >
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-col>
      </v-row>
      <v-btn
        :disabled="PreviewMode"
        text
        icon
        color="error"
        @click="onRemoveMe"
        class="float-right"
      >
        Remove
      </v-btn>
    </v-card>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
export default {
  name: "CallFlowRedirect",
  components: {},
  props: {
    FlowId: {
      type: Number,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    updateCallback: {
      type: Function,
      required: false
    },
    onRemove: {
      type: Function,
      required: true
    },
    flowList: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    PreviewMode: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      rules: VALIDATION_RULES,

      selectedRedirectTo: null
    };
  },
  created() {
    if (
      this.order != null &&
      this.flowList.length > 0 &&
      this.flowList[this.order] &&
      this.flowList[this.order].redirectTo
    ) {
      const tempData = Object.assign({}, this.flowList[this.order]);
      this.selectedRedirectTo = this.callFlowType.items.filter(
        value => value.meta.uid == tempData.redirectTo
      )[0].id;
    }
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    callFlowType() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["call_flow"].includes(value))
        .first();
      return listType;
    },
    callFlowTypeId() {
      const listType = this.callFlowType;
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    otherCallFlows() {
      return this.callFlowType.items;
    },
    redirectTo() {
      const selected = this.selectedRedirectTo;
      return this.callFlowType.items.filter(
        value => value.id == this.selectedRedirectTo
      )[0].meta.uid;
    }
  },
  methods: {
    onRemoveMe() {
      this.onRemove(this.config.uid);
    },
    onUpdateAnything() {
      const newConfig = Object.assign({}, this.config);
      newConfig.order = this.order;
      newConfig.redirectTo = this.redirectTo;
      this.updateCallback(this.order, newConfig);
    },
    callFlowsCustomFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    }
  }
};
</script>

<style scoped lang="stylus">
.call-flow-icon {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  font-weight: 400;
}
.flow-line {
  height: 3rem;
  width: 100%;
}
.flow-line-inside {
  height: 3rem;
  width: 50%;
  border-right: 1px solid #cccccc;
}
.setup-settings-menu {
  background: white;
}
</style>
